import { Stack, Switch, Typography, useTheme } from "@mui/material";
import BugReportIcon from "@mui/icons-material/BugReport";
import { useDebugContext } from "src/context/Debug/DebugContext";

export const ProfilingToggle = () => {
    const theme = useTheme();
    const { isProfilingEnabled, toggleProfiling } = useDebugContext();

    return (
        <Stack direction="row" alignItems="center" spacing={1}>
            <Switch checked={isProfilingEnabled} onChange={toggleProfiling} size="small" />
            <BugReportIcon
                sx={{
                    fontSize: 16,
                    color: isProfilingEnabled ? theme.palette.warning.main : theme.custom.grey[1200],
                }}
            />
            <Typography
                variant="caption"
                sx={{
                    color: isProfilingEnabled ? theme.palette.warning.main : theme.custom.grey[1200],
                    fontSize: "11px",
                }}
            >
                {isProfilingEnabled ? "Profiling ON" : "Profiling OFF"}
            </Typography>
        </Stack>
    );
};
